import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 1. 预获取订单数据
export function getOrderInfo (params) {
    return request({
        url: `${parent}/api/order/info/pre`,
        method: 'get',
        params
    })
}

/**
 * 创建订单
 * @param { object } data
 * @param { string } data.couponCode - 券码
 * @param { number } data.masterId - 班主任 ID
 * @param { string } data.secondChannel - 下单二级渠道
 * @param { number } data.stId - 员工 Staff ID
 * @param { number } data.stageId - 课期 ID
 * @param { number } data.studentId - 学生 ID
 */
export function createOrder (data) {
    return request({
        url: `${parent}/api/order/create`,
        method: 'post',
        data
    })
}

/**
 * 创建大米网校订单
 * @param { object } data
 * @param { string } data.channelId - 渠道 ID，用于标识订单来源
 * @param { number } data.skuId - 网校商品 ID
 * @param { number } data.spuId - 网校 SPU ID
 * @param { number } data.studentId - 学生 ID
 */
export function createDamiOrder (data) {
    return request({
        url: `${parent}/api/order/dami/create`,
        method: 'post',
        data
    })
}
